__turbopack_context__.v({
  "image": "UserAvatar-module__597U6a__image",
  "initial": "UserAvatar-module__597U6a__initial",
});
